import { render } from "./adminsidebar.vue?vue&type=template&id=b4c184b2"
import script from "./adminsidebar.vue?vue&type=script&lang=js"
export * from "./adminsidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__